<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import CustomerOrders from "../orders/customer-order";
import CustomerContracts from "../contracts/customer-contract";
// import CustomerDashboard from "../dashboard-customer/index";
import CustomerChecks from "../customer/customer-check";
import Swal from 'sweetalert2';
// import ReferenceEdit from "@/components/modals/reference_admin_modal.vue";
import { usePermissions } from '@/composables/usePermissions';

export default {
  page: {
    title: "Customer Information",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      activeTab: 'home',
      role: localStorage.getItem('role'),
      title: "Customer Information",
      items: [
        {
          text: "Customer",
          href: "/",
        },
        {
          text: "Customer Information",
          active: true,
        },
      ],
      customer_id: this.$route.params.id,
      customer_info: [],
      customer_order_info: [],
      listState: [],
      referencesList: [],
      
      customer_first_name: '',
      customer_last_name: '',
      nric: '',
      phone_no: '',
      email_address: '',
      email_address_corporate: '',
      gender: '',
      dob: '',
      race: '',
      alt_contact_name: '',
      alt_contact_number: '',
      
      address: '',
      postalcode: '',
      city: '',
      state: '',
      payslip: '',
      
      salary: '',
      employment_company_name: '',
      employment_office_gneral_line: '',
      customer_loan: '',
      front_nric: '',
      back_nric: '',
      customer_full_name: '',
      ref_id: '', 
      temporary_id:'',
      ref_name:'',
      ref_relationship:'',
      ref_number:'',
      BaseUrlfile: process.env.VUE_APP_API_BASEURL_FILE,
      cust_id:'',
      rangeSalary:'',
      netSalary:'',
      uploadPayslip_:'',
      uploadAdditonalDoc_:'',
      uploadAdditonalDoc1_:'',
      uploadAdditonalDoc2_:'',
      uploadAdditonalDoc3_:'',
      uploadAdditonalDoc4_:'',
      listRelation:[],
      relationship:'',
      sucessaddmsd:'',
      sucessemplmsd:'',
      sucessupload:'',
      uploadstat:'',
      nameperic:'',
      additional_doc:'',
      bnk_name:'',
      total_outstanding_amount:'',
      total_unresolved_invoice:'',
      total_late_payment:'',
      invoice_list:'',
      showAr:'',
      orderId:'',
      order_status_id:'',
      nricOrders: [],
      loadingNric: false,
      cloudFrontURL: process.env.VUE_APP_BUCKET,

    };
  },
  setup() {
        const {
            canReadCustomers,
            canReadCustomersList,
            canCreateCustomers,
            canCreateCustomersList,
            canUpdateCustomers,
            canUpdateCustomersList,
            canReadAgingReport,
            arPermissions
        } = usePermissions()
        return {
            canReadCustomers,
            canReadCustomersList,
            canCreateCustomers,
            canCreateCustomersList,
            canUpdateCustomers,
            canUpdateCustomersList,
            canReadAgingReport,
            arPermissions        
          };
    },
  methods: {
    async loadNricOrders() {
        if (!this.nric) return;
        this.loadingNric = true;
        try {
          const res = await axios.get(
            `${process.env.VUE_APP_API_BASEURL}customer/by-nric/${this.nric}`
          );
          this.nricOrders = res.data;
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingNric = false;
        }
      },
    goToCustomer(customerId) {
    // 1. Only navigate if not already on the same page
    if (this.$route.params.id != customerId) {
      // 2. Push new route
      this.$router.push({
        path: `/customer/customer-details/${customerId}`
      }).then(() => {
        // 3. Force full page reload after navigation
        window.location.reload();
      });
    }
  },
    async getBank(){
        await axios.get(process.env.VUE_APP_API_NODEJS+'/bankList')
        .then(response => {
            console.log("BANK", response.data)
            if (response) {
                this.listBank=response.data;
                // alert(response.data['0'].id['0'])
                                        
            } else {
                this.messageBag = ['No record.'];
                this.OrderSeen = false;
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
                this.OrderSeen = false;
        });
    },
    
    format_date(value){
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY H:m:s')
        }
    },
    get_customer_by_id(){
        this.showAr = localStorage.getItem('showAr');
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/details/'+this.$route.params.id)
        .then(response => {

            if (response) {
                this.loadingRoles=false;
                this.customer_info = response.data;
                console.log("Customer Info",this.customer_info);
                this.cust_id = this.customer_info[0].id;
                this.customer_first_name = this.customer_info[0].first_name;
                this.customer_last_name = this.customer_info[0].last_name;
                this.nameperic = this.customer_info[0].name_as_per_nric;
                this.customer_full_name = this.customer_info[0].first_name +' '+ this.customer_info[0].last_name;
                this.nric = this.customer_info[0].nric;
                this.phone_no = this.customer_info[0].phone_number;
                this.email_address = this.customer_info[0].email;
                this.email_address_corporate = this.customer_info[0].emailAddresscorporate;
                this.gender = this.customer_info[0].gender;
                this.dob = this.customer_info[0].dob;
                this.race = this.customer_info[0].race_cus;
                this.alt_contact_name = this.customer_info[0].phone_no;
                this.alt_contact_number = this.customer_info[0].phone_no;
                this.additional_doc = this.customer_info[0].additional_doc;
                this.additional_doc1 = this.customer_info[0].additional_doc1;
                this.additional_doc2 = this.customer_info[0].additional_doc2;
                this.additional_doc3 = this.customer_info[0].additional_doc3;
                this.additional_doc4 = this.customer_info[0].additional_doc4;
                
                this.address = this.customer_info[0].address;
                this.postalcode = this.customer_info[0].postalcode;
                this.city = this.customer_info[0].city;
                this.state = this.customer_info[0].state;

				this.order_id = this.customer_info[0].order_id;
                

                this.employment_company_name = this.customer_info[0].employment_company_name;
                this.employment_office_gneral_line = this.customer_info[0].employment_office_gneral_line;
                this.customer_loan = this.customer_info[0].customer_loan;
                
                this.rangeSalary = this.customer_info[0].salary_range;
                this.netSalary = this.customer_info[0].net_salary;
                this.uploadPayslip_ = this.payslip;

                this.upload_payslip1 = this.customer_info[0].upload_payslip1;
                this.upload_payslip2 = this.customer_info[0].upload_payslip2;
                this.upload_payslip3 = this.customer_info[0].upload_payslip3;

                this.upload_bankstatemnt1 = this.customer_info[0].upload_bankstatemnt1;
                this.upload_bankstatemnt2 = this.customer_info[0].upload_bankstatemnt2;
                this.upload_bankstatemnt3 = this.customer_info[0].upload_bankstatemnt3;

                this.bnk_acc = this.customer_info[0].bnk_acc;
                this.bnk_name = this.customer_info[0].bnk_name;
                console.log('--'+this.bnk_name+'--');
                if(this.customer_info[0].net_salary === null){
                  this.salary = this.customer_info[0].salary_range;
                }else{
                  this.salary = this.customer_info[0].net_salary;
                }
                
                // if(this.customer_info[0].salary_range != ''){
                //   this.salary = this.customer_info[0].salary_range;
                // }

                if(this.customer_loan.includes('None')){
                  this.payslip = this.customer_info[0].upload_payslip;
                  this.salary = this.customer_info[0].net_salary;
                  
                }else{
                  this.payslip = null;
                }

                
                
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_order_by_id(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/order_details/'+this.$route.params.id)
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.customer_order_info = response.data; 
                this.front_nric = this.customer_order_info[0].front_nric;
                this.back_nric = this.customer_order_info[0].back_nric;
                this.orderId = this.customer_order_info[0].orderId;
                this.order_status_id = this.customer_order_info[0].order_status_id;
                
                console.log(this.customer_info);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_references(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'reference/list/'+this.$route.params.id)
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.referencesList = response.data;
                console.log("Refercence List",this.referencesList);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    //raw data----------------------------------------------------------
    get_channel_partner(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'channelpartner/raw_data')
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.channelpartnerlist = response.data;
                console.log(this.channelpartnerlist);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_country(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data_country')
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.countryList = response.data;
                console.log(this.countryList);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    getState(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'statelist/raw_data')
        .then(response => {
            if (response) 
            {
              this.listState = response.data;
              console.log("State",response.data)     
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },
    //raw data----------------------------------------------------------
    editReference(item) {
        this.ref_id = item.id;
        this.temporary_id = item.temp_id;
        this.ref_name = item.name;
        this.ref_number = item.contact_number;
        this.relationship = item.relation_id      
    },
    getRelationList(){

        axios.get(process.env.VUE_APP_API_BASEURL+'relation/list')
        .then(response => {
            if (response) {
                this.listRelation=response.data;
                
            } else {
                this.messageBag = ['No record.'];
                this.OrderSeen = false;
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
                this.OrderSeen = false;
        });
    },
    refupdate(){
                const posting_ = { 
                    ref_name: this.ref_name, 
                    ref_number: this.ref_number, 
                    relationship: this.relationship,
                    temp_id: this.temporary_id, 
                };
                // console.log(posting_);
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'ref/update/'+ this.ref_id, posting_)
                .then(response => {
                    if (response) {
                        // this.ref_name = '';
                        // this.relationship = '';
                        // this.ref_number = '';
                        // this.refList();
                        this.get_references();
                        console.log("success");
                    } else {
                        this.messageBag = ['No record.'];
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
    },

    custUpdate(id){
                const posting_ = { 
                    address: this.address, 
                    postalcode: this.postalcode, 
                    city: this.city,
                    state: this.state, 
                };
                // console.log(posting_);
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/update/'+ id, posting_)
                .then(response => {
                    if (response) {
                        // this.ref_name = '';
                        // this.relationship = '';
                        // this.ref_number = '';
                        // this.refList();
                        this.sucessaddmsd = "Data Saved Successfully"
                    } else {
                        this.messageBag = ['No record.'];
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
      },

      uploadPayslipF(){
                this.uploadPayslip_ = this.$refs.uploadPayslip.files[0];
      },
      uploadAdditionaldoc(){
                this.uploadAdditonalDoc_ = this.$refs.uploadAdditonalDoc.files[0];
      },
       uploadAdditionaldoc1(){
                this.uploadAdditonalDoc1_ = this.$refs.uploadAdditonalDoc1.files[0];
      },
      uploadAdditionaldoc2(){
                this.uploadAdditonalDoc2_ = this.$refs.uploadAdditonalDoc2.files[0];
      },
      uploadAdditionaldoc3(){
                this.uploadAdditonalDoc3_ = this.$refs.uploadAdditonalDoc3.files[0];
      },
      uploadAdditionaldoc4(){
                this.uploadAdditonalDoc4_ = this.$refs.uploadAdditonalDoc4.files[0];
      },

      submitAdditionaldoc(id){
        const formData = new FormData();

        formData.append(
            'uploadAdditonalDoc', this.uploadAdditonalDoc_,
        );
        formData.append(
            'uploadAdditonalDoc1', this.uploadAdditonalDoc1_,
        ); formData.append(
            'uploadAdditonalDoc2', this.uploadAdditonalDoc2_,
        ); formData.append(
            'uploadAdditonalDoc3', this.uploadAdditonalDoc3_,
        );
        formData.append(
            'uploadAdditonalDoc4', this.uploadAdditonalDoc4_,
        );

        const headers = { 'Content-Type': 'multipart/form-data' };
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        // if(this.uploadAdditonalDoc_ != '' && this.uploadAdditonalDoc_1 != '' && this.uploadAdditonalDoc_2 != ''&& this.uploadAdditonalDoc_3 != ''&& this.uploadAdditonalDoc_4 != ''){
              axios.post(process.env.VUE_APP_API_BASEURL+'uploadAddionaldoc/'+ id, formData, { headers }).then((res) => {
              res.data.files; // binary representation of the file
              res.status; // HTTP status
              if(res.data.status == 'success'){
                this.uploadstat = 'success';
                this.sucessupload = "Data Saved"
                setTimeout(location.reload.bind(location), 2000);

              }else{
                this.uploadstat = 'error';
                this.sucessupload = "Wrong File Extension"
              }
            });
        // }else{
        //   alert('Please Upload Document first')
        // }
       
      },

      sallaryUpdate(id){
          const formData = new FormData();
          formData.append(
              'uploadPayslip', this.uploadPayslip_,
          );

          formData.append(
              'net_salary', this.salary,
          );

          formData.append(
              'employment_company_name', this.employment_company_name,
          );

          formData.append(
              'employment_office_gneral_line', this.employment_office_gneral_line,
          );

          formData.append(
              'loan', this.customer_loan,
          );

          // formData.append(
          //     'salary_range', this.salary,
          // );

          // const posting_ = { 
          //     employment_company_name: this.employment_company_name, 
          //     employment_office_gneral_line: this.employment_office_gneral_line, 
          //     salary_range: this.salary,
          //     net_salary: this.salary, 
          //     uploadPayslip : this.uploadPayslip_,
          //     loan : this.customer_loan,
          // };
          // console.log(posting_);
          const headers = { 'Content-Type': 'multipart/form-data' };
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.post(process.env.VUE_APP_API_BASEURL+'salary/update/'+ id+'/'+this.$route.params.hash, formData, { headers }).then((res) => {
                res.data.files; // binary representation of the file
                res.status; // HTTP status
                this.sucessemplmsd = "Data Saved";
              });
              setTimeout(location.reload.bind(location), 2000);
        },

		toNric(type){


			axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
			axios.get(process.env.VUE_APP_API_BASEURL+'create/token/s3?type='+type+'&order_id='+this.order_id)
			.then(response => {
				if (response) {
					this.token = '';
					if(response.data != 0){
						this.token = response.data;
						window.open(process.env.VUE_APP_LANDING+'/nricimage?token='+this.token,'_blank');
					}
				} 
				else {
					this.messageBag = ['No record.'];
				}
			})
			.catch(error => {
				this.messageBag = [error.error];
			});
			
			
			
		},

    getdashboarddata(){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_AR_API_BASEURL+'dashboard/customer/info/'+this.$route.params.id)
      .then(response => {
        if (response) {
          console.log("dashboard",response.data);
          this.total_outstanding_amount = response.data.total_outstanding_amount;
          this.total_late_payment = response.data.total_late_payment;
          this.total_unresolved_invoice = response.data.total_unresolved_invoice;
        } 
        else {
          this.messageBag = ['No record.'];
        }
      })
      .catch(error => {
        this.messageBag = [error.error];
      });
      },
      
      getinvoicelist(){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/invoiceListing')
      .then(response => {
        if (response) {
          console.log("invoicelist",response.data[0]);
          this.invoice_list = response.data[0];
        } 
        else {
          this.messageBag = ['No record.'];
        }
      })
      .catch(error => {
        this.messageBag = [error.error];
      });
      },
      deleteToDo() {
        localStorage.removeItem('showAr');
      },
        update_information() {

            Swal.fire({
              title: 'Are you sure want to update customer information?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Update!'
            }).then((result) => {
              if (result.value) {
                
                const posting_ = { 
                    customer_name: this.nameperic,
                    nric: this.nric,
                    phone_no: this.phone_no,
                    email_address: this.email_address,
                    gender: this.gender,
                    dob: this.dob,
                    race: this.race,
                };
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/detail/update/'+ this.$route.params.id, posting_)
                .then( response => {
                    if (response.status == 200) {
                        Swal.fire({
                        title: 'Customer Information Updated!',
                        icon: 'success',
                        timer: 1000,
                        showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                        title: 'Customer Information Failed to Update!',
                        icon: 'warning',
                        timer: 1000,
                        showConfirmButton: false,
                        });
                    }
                }).catch(error => {
                    Swal.fire({
                    title: 'Customer Information Failed to Update!',
                    html: error.response.data.msj,
                    icon: 'warning',
                    showConfirmButton: true,
                    });
                });
              }
            });

            
        },
    },

  components: {
      Layout,
      PageHeader,
      CustomerOrders, 
      CustomerContracts,
      CustomerChecks,
      // CustomerDashboard,
      // ReferenceEdit
  },

  mounted() {
      this.get_customer_by_id();
      this.getState();
      this.get_references();
      this.get_customer_order_by_id();
      this.getRelationList();
      this.getBank();
      this.getdashboarddata();
      this.getinvoicelist();
      this.deleteToDo();
      this.loadNricOrders();
  },
  watch: {
    nric(newVal) {
      if (newVal) this.loadNricOrders();
    }
  },
  computed: {
    containsARModule() {
      const menus = JSON.parse(localStorage.getItem('menus') || '[]');
      return menus.some(tab => tab.tab_link === "#ARModule");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header border-0">
            <div class="d-flex align-items-center justify-content-between">
              <!-- Left: Customer Name -->
              <h3 class="mb-0">
                <i class="ri-function-fill text-muted align-bottom me-1"></i>
                {{ nameperic }}
              </h3>

              <!-- Right: NRIC Orders Dropdown -->
              <div class="dropdown" v-if="nricOrders.length > 1">
                <button
                  class="btn btn-outline-secondary btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  :disabled="loadingNric"
                >
                  <i class="ri-file-list-3-line align-bottom me-1"></i>
                  Orders ({{ nricOrders.length }})
                  <span class="spinner-border spinner-border-sm ms-2" v-if="loadingNric"></span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li v-for="item in nricOrders" :key="item.order_id">
                    <a
                      href="javascript:void(0)"
                      class="dropdown-item"
                      @click="goToCustomer(item.customer_id)"
                      :class="{ 'bg-light': $route.params.id == item.customer_id }"
                    >
                      Order #{{ item.order_id }}
                      <small class="text-muted d-block">Customer ID: {{ item.customer_id }}</small>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- If only 1 order, show nothing or a badge -->
              <div v-else-if="nricOrders.length === 1" class="text-muted small">
                <i class="ri-file-check-line"></i> 1 Order
              </div>
            </div>
          </div>
          <div>
            <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
              <li class="nav-item" @click="activeTab = 'home'">
                <a
                  class="nav-link"
                  style="cursor: pointer;"
                  v-bind:class = "(activeTab == 'home') ?'active':''"
                  role="tab"
                  aria-selected="true"
                >
                  <i class="ri-information-line text-muted align-bottom me-1"></i>
                  Summary
                </a>
              </li>
              <li class="nav-item" @click="activeTab = 'orders'">
                <a
                  class="nav-link"
                  style="cursor: pointer;"
                  v-bind:class = "(activeTab == 'orders') ?'active':''"
                  role="tab"
                  aria-selected="false"
                >
                  <i class="ri-shopping-cart-2-line text-muted align-bottom me-1"></i>
                  Orders
                </a>
              </li>
              <li class="nav-item" @click="activeTab = 'contracts'">
                <a
                  class="nav-link"
                  style="cursor: pointer;"
                  v-bind:class = "(activeTab == 'contracts') ?'active':''"
                  role="tab"
                  aria-selected="false"
                >
                  <i class="ri-file-edit-line text-muted align-bottom me-1"></i>
                  Contracts
                </a>
              </li>
              <li class="nav-item" @click="activeTab = 'checks'">
                <a
                  class="nav-link"
                  style="cursor: pointer;"
                  v-bind:class = "(activeTab == 'checks') ?'active':''"
                  role="tab"
                  aria-selected="false"
                >
                  <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
                  Customer Checks
                </a>
              </li>
              <li class="nav-item" v-if="(order_status_id == 1 || order_status_id == 2) && containsARModule">
                <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar'" class="nav-link">
                    <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
                    AR
                </router-link>
              </li>
            </ul>
          </div>
          <div class="card-body p-4">
            <div class="tab-content text-muted">
              <div v-show="activeTab == 'home'">
                <div class="row">
                  <div class="col-xl-7">
                    <div class="card">
                      <div class="card-header bg-light">
                        <div class="d-flex align-items-center">
                          <h5><i class="ri-account-box-line text-muted align-bottom me-1"></i>CONTACT INFORMATION</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <form @submit.prevent="update_information">
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="customer_name" class="form-label">Customer Name (as per IC)</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='nameperic' type="text" class="form-control" id="customer_name" />
                              </div>
                            </div>                           
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="NRIC" class="form-label">IC Number</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='nric' type="text" class="form-control" id="nric" readonly/>
                              </div>
                            </div>

                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="customer_name" class="form-label"></label>
                              </div>
                              <div class="col-lg-9">
                                <a href='javascript:;' @click='toNric("front")' >Click Here to View NRIC (Front)</a> <br>
                                <a href='javascript:;' @click='toNric("back")'>Click Here to View NRIC (Back)</a>
                              </div>
                            </div>

                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="phone_no" class="form-label">Mobile Number</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='phone_no' type="text" class="form-control" id="phone_no" />
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="email_address" class="form-label">Email Address</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='email_address' type="text" class="form-control" id="email_address" />
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="email_address_corporate" class="form-label">Corporate Email Address</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='email_address_corporate' type="text" class="form-control" id="email_address_corporate" />
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="gender" class="form-label">Gender</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='gender' type="text" class="form-control" id="gender" />
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="dob" class="form-label">DOB</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='dob' type="date" class="form-control" id="dob" />
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="race" class="form-label">Race</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='race' type="text" class="form-control" id="race" />
                              </div>
                            </div>
                            <hr class="my-4 text-muted">
                              <div class="text-end col-lg-12">
                                <button v-if="canUpdateCustomers || canUpdateCustomersList" type="submit" class="btn btn-primary">
                                  Update
                                </button>
                              </div>
                          </form>
                        </div>
                      </div>
                      <div class="card-header bg-light">
                        <div class="d-flex align-items-center">
                          <h5><i class="ri-contacts-book-line text-muted align-bottom me-1"></i>REFERENCES INFORMATION</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="col-md-12">
                          <table v-if="referencesList" class="table"> 
                                <thead class="table-light">
                                  <tr>
                                      <th>#.</th>
                                      <th scope="col">Name</th>           
                                      <th scope="col">Contact No</th>           
                                      <th scope="col">Relationship</th>  
                                      <th v-if="canUpdateCustomers || canUpdateCustomersList" scope="col">Action</th>                                                
                                  </tr>
                              </thead>

                              <tbody>                        
                                  <tr v-for="(item, index) in referencesList" :key="index" class="content">
                                      <td>{{ index+1 }}</td>                                                                                                 
                                      <td>{{ item.name }}</td>                                     
                                      <td>{{ item.contact_number }}</td>                                                                            
                                      <td>{{ item.relation }}</td>  
                                      <td v-if="canUpdateCustomers || canUpdateCustomersList" ><button class="btn btn-primary pr-3" type="button" data-bs-toggle="modal" data-bs-target="#referenceEditModal" @click="editReference(item)">Edit</button></td>                                                                                                                                                      
                                    </tr>
                              </tbody>
                          </table>
                          <!-- <ReferenceEdit :id="ref_id" :temp_id="temporary_id" :name="ref_name" :number="ref_number" :relationship_id="ref_relationship"></ReferenceEdit> -->
                          <div class="modal fade" id="referenceEditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header"><button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button></div>
                                            <div class="modal-body">
                                                            <form>
                                                                <div class="row gy-4">
                                                          
                                                                    <div class="col-md-12">
                                                                        <div>
                                                                            <label for="basiInput" class="form-label">Name<span style="color: red;">*</span></label>
                                                                            <input v-model="ref_name" type="text" class="form-control" placeholder="Enter name" required>
                                                        
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div>
                                                                            <label for="basiInput" class="form-label align-left">Relationship<span style="color: red;">*</span></label>
                                                                            <select v-model="relationship" class="form-select mb-3" arial-label="Default select example" required>
                                                                                <option value="">Please Select Relationship</option>
                                                                                <option v-for="(item,index) in listRelation" :key="index" :value="item.id" >{{ item.name }}</option>
                                                                            </select>
                                                                        
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div>
                                                                            <label for="basiInput" class="form-label">Mobile Number<span style="color: red;">*</span></label>
                                                                            <input v-model="ref_number" type="text" class="form-control" placeholder="Enter Mobile Number" maxlength="10" minlength="9" required>
                                                                          
                                                                        </div>
                                                                    </div>
                                                                
                                                                
                                                                    <div class="col-md-6">
                                                                        <button class="btn btn-primary waves-effect waves-light" type="button" @click="refupdate()" data-bs-dismiss="modal"><span>Save</span></button>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                        </div>
                      </div>

                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5><i class="ri-money-dollar-circle-line text-muted align-bottom me-1"></i>CREDIT FACILITY</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="col-md-12">
                          <label for="zip" class="form-label"><i class="ri-subtract-fill text-muted align-bottom me-1"></i> {{ customer_loan }}</label>
                          <!--input v-model='customer_loan' type="text" class="form-control" id="customer_loan" -->
                        </div>
                      </div>

                    </div>  
                    
                    <div class="card">
                      <div class="card-header bg-light">
                        <div class="d-flex">
                          <h5><i class="ri-briefcase-line text-muted align-bottom me-1 text-uppercase"></i>ADDITIONAL DOCUMENTS</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div>
                            <div class="row g-3">                               
                                <div v-if="canUpdateCustomers || canUpdateCustomersList" class="col-md-12">
                                    <label for="placeholderInput" class="form-label">Additional Documents Upload 1<span style="color: red;">*</span></label>
                                    <input type="file" ref="uploadAdditonalDoc" @change="uploadAdditionaldoc" class="form-control" required>
                                    <label for="zip" class="form-label">Additional Document :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a v-if="this.additional_doc !=null" v-bind:href="cloudFrontURL+additional_doc" target="_blank" rel="noreferrer noopener">Click Here to View Additional Doc</a>
                                </div>
                                <div v-if="canUpdateCustomers || canUpdateCustomersList" class="col-md-12">
                                    <label for="placeholderInput" class="form-label">Additional Documents Upload 2<span style="color: red;">*</span></label>
                                    <input type="file" ref="uploadAdditonalDoc1" @change="uploadAdditionaldoc1" class="form-control" required>
                                    <label for="zip" class="form-label">Additional Document :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a v-if="this.additional_doc1 !=null" v-bind:href="cloudFrontURL+additional_doc1" target="_blank" rel="noreferrer noopener">Click Here to View Additional Doc</a>
                                </div> 
                                <div v-if="canUpdateCustomers || canUpdateCustomersList" class="col-md-12">
                                    <label for="placeholderInput" class="form-label">Additional Documents Upload 3<span style="color: red;">*</span></label>
                                    <input type="file" ref="uploadAdditonalDoc2" @change="uploadAdditionaldoc2" class="form-control" required>
                                    <label for="zip" class="form-label">Additional Document :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a v-if="this.additional_doc2 !=null" v-bind:href="cloudFrontURL+additional_doc2" target="_blank" rel="noreferrer noopener">Click Here to View Additional Doc</a>
                                </div> 
                                <div v-if="canUpdateCustomers || canUpdateCustomersList" class="col-md-12">
                                    <label for="placeholderInput" class="form-label">Additional Documents Upload 4<span style="color: red;">*</span></label>
                                    <input type="file" ref="uploadAdditonalDoc3" @change="uploadAdditionaldoc3" class="form-control" required>
                                    <label for="zip" class="form-label">Additional Document :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a v-if="this.additional_doc3 !=null" v-bind:href="cloudFrontURL+additional_doc3" target="_blank" rel="noreferrer noopener">Click Here to View Additional Doc</a>
                                </div> 
                                <div v-if="canUpdateCustomers || canUpdateCustomersList" class="col-md-12">
                                    <label for="placeholderInput" class="form-label">Additional Documents Upload 5<span style="color: red;">*</span></label>
                                    <input type="file" ref="uploadAdditonalDoc4" @change="uploadAdditionaldoc4" class="form-control" required>
                                    <label for="zip" class="form-label">Additional Document :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a v-if="this.additional_doc4 !=null" v-bind:href="cloudFrontURL+additional_doc4" target="_blank" rel="noreferrer noopener">Click Here to View Additional Doc</a>
                                </div>      

                            </div>
                            <button v-if="canUpdateCustomers || canUpdateCustomersList" class="btn btn-primary waves-effect waves-light" type="button" @click="submitAdditionaldoc(cust_id)"><span>Save</span></button>
                            <br>
                            <span style="color: green;" v-if="uploadstat =='success'">
                                {{ sucessupload }}
                            </span>
                            <span style="color: red;" v-else>
                                {{ sucessupload }}
                            </span>
                            <hr class="my-4 text-muted">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-5">    
                    <div class="card">
                      <div class="card-header bg-light">
                        <div class="d-flex">
                          <h5><i class="ri-map-pin-user-line text-muted align-bottom me-1"></i>CORRESPONDENCE ADDRESS</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div>
                            <div class="row g-3">
                                <div class="col-12">                        
                                    <textarea v-model="address" rows="4" class="form-control" id="address" placeholder="" ></textarea>
                                </div>
                                <div class="col-md-6">
                                    <label for="zip" class="form-label">City</label>
                                    <input v-model='city' type="text" class="form-control" id="city" placeholder="">
                                </div>
                                <div class="col-md-6">
                                    <label for="zip" class="form-label">Postcode</label>
                                    <input v-model='postalcode' type="text" class="form-control" id="postalcode" placeholder="">
                                </div>       
                                <div class="col-md-6">
                                    <label for="zip" class="form-label">State</label>
                                    <select v-model="state" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                                      <option value="">--- Select State ---</option>
                                      <option v-for="(item, index) in listState" :key="index" :value="item.id" >
                                          {{ item.name }}
                                      </option>
                                    </select>
                                </div>
                                

                                <!--div class="col-md-6">
                                    <label for="country" class="form-label">Country</label>
                                    <select v-model="country_id" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                                      <option value="">--- Select Country ---</option>
                                      <option v-for="(item, index) in countryList" :key="index" :value="item.id" >
                                          {{ item.name }}
                                      </option>
                                    </select>
                                </div-->  
                            </div>
                            <button v-if="canUpdateCustomers || canUpdateCustomersList" class="btn btn-primary waves-effect waves-light" type="button" @click="custUpdate(cust_id)"><span>Save</span></button>
                            <span style="color: green;" v-if="sucessaddmsd !=''">
                                {{ sucessaddmsd }}
                            </span>
                            <hr class="my-4 text-muted">
                        </div>
                      </div>
                    </div>

                    <!--div class="card">
                      <div class="card-header">
                        <div class="d-flex">
                          <h5><i class="ri-map-pin-user-line text-muted align-bottom me-1"></i>CORRESPONDENCE ADDRESS</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div>
                            <div class="row g-3">
                                <div class="col-12">                        
                                    <textarea v-model="address" rows="4" class="form-control" id="address" placeholder="" ></textarea>
                                </div>
                                <div class="col-md-6">
                                    <label for="zip" class="form-label">City</label>
                                    <input v-model='city' type="text" class="form-control" id="city" placeholder="">
                                </div>
                                <div class="col-md-6">
                                    <label for="zip" class="form-label">Postcode</label>
                                    <input v-model='postalcode' type="text" class="form-control" id="postalcode" placeholder="">
                                </div>       
                                <div class="col-md-6">
                                    <label for="zip" class="form-label">State</label>
                                    <select v-model="state" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                                      <option value="">--- Select State ---</option>
                                      <option v-for="(item, index) in listState" :key="index" :value="item.id" >
                                          {{ item.name }}
                                      </option>
                                    </select>
                                </div>
                                
                                <div class="col-md-6">
                                    <label for="country" class="form-label">Country</label>
                                    <select v-model="country_id" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                                      <option value="">--- Select Country ---</option>
                                      <option v-for="(item, index) in countryList" :key="index" :value="item.id" >
                                          {{ item.name }}
                                      </option>
                                    </select>
                                </div>  
                            </div>
                            
                            <hr class="my-4 text-muted">
                        </div>
                      </div>
                    </div-->

                    <div class="card">
                      <div class="card-header bg-light">
                        <div class="d-flex">
                          <h5><i class="ri-briefcase-line text-muted align-bottom me-1"></i>EMPLOYMENT INFORMATION</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div>
                            <div class="row g-3">                               
                                <div class="col-md-12">
                                    <label for="zip" class="form-label">Company Name</label>
                                    <input v-model='employment_company_name' type="text" class="form-control" id="employment_company_name">
                                </div>                               
                            </div>
                            <br>
                            <div class="row g-3">                                                               
                                <div class="col-md-12">
                                    <label for="zip" class="form-label">Office General Line</label>
                                    <input v-model='employment_office_gneral_line' type="text" class="form-control" id="employment_office_gneral_line">
                                </div>                                                                                                     
                            </div>
                            <br>
                            <div class="row g-3">                               
                                <div class="col-md-12">
                                    <label for="zip" class="form-label">Net Salary/Salary Range</label>
                                    <input  v-model='salary' type="text" class="form-control" id="salary" />
                                    <!-- v-if="this.customer_loan === 'None'||this.customer_loan === null || this.netSalary != null" -->
                                      <!-- <select v-else type="text" class="form-select" placeholder="Select Range" v-model="salary" arial-label="Default select example" required>
                                        <option :value="salary">
                                        {{ salary }}
                                        </option>
                                        <option value="MYR 0 - MYR 2,500">
                                            MYR 0 - MYR 2,500
                                        </option>
                                        <option value="MYR 2,501 - MYR 3,000">
                                            MYR 2,501 - MYR 3,000
                                        </option>
                                        <option value="MYR 3,001 - MYR 5,000">
                                            MYR 3,001 - MYR 5,000
                                        </option>
                                        <option value="MYR 5,001 - MYR 8,000">
                                            MYR 5,001 - MYR 8,000
                                        </option>
                                        <option value="MYR 8,001 and Above">
                                            MYR 8,001 and Above
                                        </option>
                                      </select> -->
                                </div>                               
                            </div>
                            <br>
                            <div v-if="canUpdateCustomers || canUpdateCustomersList" class="row g-3">                               
                                <div class="col-md-12" v-if="customer_loan == 'None'">
                                   
                                    <label for="placeholderInput" class="form-label">Upload your latest one month Payslip<span style="color: red;">*</span></label>
                                    <input type="file" ref="uploadPayslip" @change="uploadPayslipF" class="form-control" required>
                                    <label for="zip" class="form-label">Latest Payslip :</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a v-bind:href="cloudFrontURL+payslip" target="_blank" rel="noreferrer noopener">Click Here to View Payslip</a>
                                  </div>                               
                            </div>

                            
                            
                            <button v-if="canUpdateCustomers || canUpdateCustomersList" class="btn btn-primary waves-effect waves-light" type="button" @click="sallaryUpdate(cust_id)"><span>Save</span></button>
                            <br>
                            <span style="color: green;" v-if="sucessemplmsd !=''">
                                {{ sucessemplmsd }}
                            </span>
                            <hr class="my-4 text-muted">
                            <div >                               
                                <div class="col-md-12" v-if="bnk_acc != NULL">
                                    Account Bank Name:
                                    <select @change="onChange($event)" v-model="bnk_name" class="form-select mb-3" arial-label="Default select example" disabled>
                                        <option v-for="(item, index) in listBank" :key="index.id" :value=item.id[0]>
                                            {{ item.name.toString().replace(/['"]+/g, '') }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div >                               
                                <div class="row g-3" v-if="bnk_acc != NULL">                               
                                  <div class="col-md-12">
                                      <label for="zip" class="form-label">Bank Account Number</label>
                                      <input v-model='bnk_acc' type="text" class="form-control" id="bnk_acc" disabled>
                                  </div>                               
                              </div>
                            </div>
                            
                            <div >                               
                                <div class="col-md-12" v-if="upload_payslip1 != NULL">
                                    <a href='javascript:;' @click='toNric("upload_payslip1")' >View Payslip Upload 1</a> <br>
                                </div>
                            </div>
                            <div >
                                <div class="col-md-12" v-if="upload_payslip2 != NULL">
                                    <a href='javascript:;' @click='toNric("upload_payslip2")'>View Payslip Upload 2</a> <br>
                                </div>
                            </div>
                            <div >
                                <div class="col-md-12" v-if="upload_payslip3 != NULL">
                                    <a href='javascript:;' @click='toNric("upload_payslip3")'>View Payslip Upload 3</a> <br>
                                </div>
                            </div>

                            <div >                               
                                <div class="col-md-12" v-if="upload_bankstatemnt1 != NULL">
                                    <a href='javascript:;' @click='toNric("upload_bankstatemnt1")'>View Bank Statement Upload 1</a> <br>
                                </div>
                            </div>
                            <div >
                                <div class="col-md-12" v-if="upload_bankstatemnt2 != NULL">
                                    <a href='javascript:;' @click='toNric("upload_bankstatemnt2")'>View Bank Statement Upload 2</a> <br>
                                </div>
                            </div>
                            <div >
                                <div class="col-md-12" v-if="upload_bankstatemnt3 != NULL">
                                    <a href='javascript:;' @click='toNric("upload_bankstatemnt3")'>View Bank Statement Upload 3</a> <br>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                


                  </div>
                </div>                                 
              </div>

              <!--orders tab-pane-->
              <div v-show="activeTab == 'orders'">
                <CustomerOrders :customerid="customer_id"  /> 
              </div>

              <!--contracts tab-pane-->
              <div v-show="activeTab == 'contracts'">
                <CustomerContracts :customerid="customer_id"  /> 
              </div>

              <!--customer checks tab-pane-->
              <div v-show="activeTab == 'checks'">
                <CustomerChecks :customerid="customer_id"  />
              </div>
              <!-- <div v-bind:class = "(showAr=='yes')?'active':''" class="tab-pane" id="arreport" role="tabpanel">
                <CustomerDashboard :outstanding_amount="total_outstanding_amount" :late_payment="total_late_payment" :unresolved_invoice="total_unresolved_invoice" :invoicelist="invoice_list" :orderId="orderId" :cust_id="cust_id"/>
              </div> -->
              <!--end tab-pane-->
            </div>
            <!--end tab-content-->
          </div>
          <!--end card-body-->
        </div>
        <!--end card -->
      </div>
      <!--end card -->
    </div>
    <!--end row-->
  </Layout>
</template>